export default {
  // Common
  common: {
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    save: 'حفظ',
    edit: 'تعديل',
    delete: 'حذف',
    loading: 'جاري التحميل...',
    loadMore: 'تحميل المزيد',
    noMore: 'لا مزيد',
    retry: 'إعادة المحاولة',
    back: 'رجوع',
    next: 'التالي',
    prev: 'السابق',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    search: 'بحث',
    filter: 'تصفية',
    sort: 'ترتيب',
    refresh: 'تحديث',
    complete: 'مكتمل',
    skip: 'تخطي',
    download: 'تحميل',
  },
  nav: {
    discover: 'الرئيسية',
    message: 'الرسائل',
    store: 'المتجر',
    mine: 'حسابي',
    recommend: 'موصى به',
  },

  // Scene
  scene: {
    changeScene: 'تغيير المشهد',
    seeAll: 'عرض الكل',
    putAway: 'طي',
    selectScene: 'اختر هذا المشهد',
    selected: 'تم الاختيار',
    sceneIndex: 'المشهد {num}',
  },
  home: {
    title: 'عالم لعب الأدوار',
    subtitle: 'ابدأ قصتك',
    startGame: 'بدء اللعبة',
    continueGame: 'استمر',
    newGame: 'لعبة جديدة',
    gameLibrary: 'المكتبة',
    featured: 'مميز',
    popular: 'شائع',
    recent: 'الأخيرة',
    searchHistory: 'البحث',
    search: 'البحث عن الأدوار...',
    noData: 'لا توجد بيانات',
    noMoreData: 'لا مزيد من البيانات',
    noNetwork: 'لا يوجد شبكة',
    pleaseSelectFilter: 'الرجاء تحديد شروط التصفية',
  },
  user: {
    login: 'تسجيل الدخول',
    register: 'التسجيل',
    logout: 'تسجيل الخروج',
    profile: 'الملف الشخصي',
    avatar: 'الصورة الرمزية',
    nickname: 'الاسم المستعار',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    oldPassword: 'كلمة المرور القديمة',
    newPassword: 'كلمة المرور الجديدة',
    forgotPassword: 'نسيت كلمة المرور',
    changePassword: 'تغيير كلمة المرور',
    bindPhone: 'ربط الهاتف',
    verifyCode: 'رمز التحقق',
    sendCode: 'إرسال الرمز',
    level: 'المستوى',
    experience: 'الخبرة',
    achievement: 'الإنجاز',
    history: 'السجل'
  },
  game: {
    character: 'الشخصية',
    story: 'القصة',
    chapter: 'الفصل',
    scene: 'المشهد',
    dialogue: 'الحوار',
    choice: 'الاختيار',
    inventory: 'الحقيبة',
    achievement: 'الإنجاز',
    save: 'حفظ اللعبة',
    load: 'تحميل اللعبة',
    restart: 'إعادة البدء',
    pause: 'إيقاف مؤقت',
    resume: 'استئناف',
    auto: 'تلقائي',
    speed: 'السرعة',
    volume: 'مستوى الصوت',
    settings: 'إعدادات اللعبة'
  },
  message: {
    success: 'نجاح',
    error: 'خطأ',
    warning: 'تحذير',
    info: 'معلومة',
    networkError: 'خطأ في الشبكة',
    serverError: 'خطأ في الخادم',
    loginSuccess: 'تم التسجيل بنجاح',
    loginFailed: 'فشل التسجيل',
    logoutSuccess: 'تم تسجيل الخروج',
    saveSuccess: 'تم الحفظ',
    saveFailed: 'فشل الحفظ',
    deleteConfirm: 'تأكيد الحذف؟',
    operationConfirm: 'تأكيد العملية؟',
    noNewsYet: 'لا توجد رسائل بعد',
    deleteSuccess: 'تم الحذف',
    deleteFailed: 'فشل الحذف',
    deleteMessage: 'هل أنت متأكد من حذف هذه الرسالة؟ لا يمكن التراجع!',
    delete: 'حذف',
    deleting: 'جاري الحذف...',
    noMoreData: 'لا مزيد من الرسائل',
    downloading: 'جاري التنزيل...',
    downloadSuccess: 'تم التنزيل',
    downloadFailed: 'فشل التنزيل',
    copySuccess: 'تم النسخ',
    copyFailed: 'فشل النسخ',
    reportSuccess: 'تم الإبلاغ',
    reportFailed: 'فشل الإبلاغ',
    translating: 'جاري الترجمة...',
    translateSuccess: 'تمت الترجمة',
    translateFailed: 'فشلت الترجمة',
    noMoreMessages: 'لا مزيد من الرسائل',
    loading_more: 'جاري التحميل...',
    pleaseWaitForReply: 'يرجى انتظار اكتمال الرد قبل الحذف',
    pleaseWaitForReplyCurrent: 'يرجى انتظار الرد على الرسالة الحالية قبل الحذف',
    chat_placeholder: 'اكتب ما تريد قوله...',
    setAsBackdropConfirm: 'تعيين كخلفية',
    setAsBackdropMessage: 'هل أنت متأكد من تعيين هذه الصورة كخلفية؟',
    sendFailed: 'فشل الإرسال',
    sending: 'جاري الإرسال...',
    introNoYet: 'لا يوجد مقدمة بعد. تحدث واكتشف بنفسك.',
    introLabel: 'المقدمة:',
    thinking: 'التفكير',
    think: 'فكر',
    translate: 'ترجمة',
    pleaseUnlock: 'يرجى إلغاء القفل',
    tryAgain: 'حاول مرة أخرى',
    create: 'إنشاء',
    free: 'مجاني',
    video: 'فيديو',
    chatMateTyping: 'شريكك في المحادثة يكتب الآن...',
    aiAssistant: 'المساعد الذكي',
    imageFailed: 'فشل في إنشاء الصورة',
    generatingImage: 'يرجى انتظار إنشاء الصورة',
    switchSceneSuccess: 'تم تبديل المشهد بنجاح',
    switchSceneFailed: 'فشل تبديل المشهد',
    switchingScene: 'جاري تبديل المشهد...',
    perMessage: '/رسالة',
    allChat: 'جميع المحادثات',
    like: 'إعجاب',
    saving: 'جاري الحفظ...',
    saved: 'تم الحفظ',
    placeholderBlur: 'اكتب ما تريد قوله...',
    placeholderFocus: 'ضع إجراءات أو تفاصيل المشهد داخل ** لإحياء المحادثة.',
    successfulSwitch: 'تم التبديل بنجاح',
    setting: 'جاري الإعداد...',
    uploading: 'جاري الرفع...',
    purchaseSuccessful: 'تم الشراء بنجاح',
    processing: 'جاري المعالجة...',
    gettingReward: 'جاري الحصول على المكافأة...',
    checkIn: 'جاري تسجيل الدخول...',
    deleteHistory: 'حذف السجل',
    openingRemarksTitle: 'قل مرحبا～',
  },
  success: {
    refreshSuccess: 'تم التحديث بنجاح',
    copiedToClipboard: 'تم النسخ إلى الحافظة',
    saved: 'تم الحفظ',
    uploadSuccess: 'تم الرفع',
    switchSuccess: 'تم التبديل بنجاح',
    thankYouPurchase: 'شكراً لك على الشراء',
  },
  error: {
    notFound: 'الصفحة غير موجودة',
    networkError: 'خطأ في الشبكة',
    serverError: 'خطأ في الخادم',
    permissionDenied: 'تم رفض الإذن',
    goHome: 'الذهاب للرئيسية',
    tryAgain: 'حاول مرة أخرى',
    uploadFailed: 'فشل الرفع',
    saveFailed: 'فشل الحفظ',
    translationFailed: 'فشلت الترجمة',
    generateImageFailed: 'فشل إنشاء الصورة',
  },
  notFound: {
    title: 'الصفحة غير موجودة',
    description: 'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
    goHome: 'الذهاب للرئيسية',
    goBack: 'العودة'
  },
  settings: {
    language: 'اللغة',
    theme: 'المظهر',
    notification: 'الإشعارات',
    privacy: 'الخصوصية',
    security: 'الأمان',
    about: 'حول',
    version: 'الإصدار',
    checkUpdate: 'التحقق من التحديث',
    clearCache: 'مسح ذاكرة التخزين المؤقت',
    systemNotification: 'إشعار النظام',
    termsOfService: 'شروط الخدمة',
    privacyPolicy: 'سياسة الخصوصية',
    title: 'الإعدادات',
    editProfile: 'تعديل الملف الشخصي',
    faq: 'الأسئلة الشائعة',
    termsOfUse: 'شروط الاستخدام',
    aboutAccount: 'حول الحساب',
    deleteAccount: 'حذف الحساب',
    logOut: 'تسجيل الخروج',
    logOutTitle: 'تسجيل الخروج',
    logOutMessage: 'بعد تسجيل الخروج، ستحتاج إلى تسجيل الدخول مرة أخرى لاستخدام حسابك. هل أنت متأكد من تسجيل الخروج؟',
    confirm: 'تأكيد',
    deleteAccountTitle: 'حذف الحساب',
    deleteAccountMessage: 'سيؤدي حذف حسابك إلى مسح جميع بياناتك ومعلوماتك ولا يمكن التراجع عن ذلك. تأكيد الحذف؟',
    deletingAccount: 'جاري حذف الحساب...',
    accountDeleted: 'تم حذف الحساب بنجاح',
    cacheTitle: 'مسح ذاكرة التخزين المؤقت',
    cacheMessage: 'مسح ذاكرة التخزين المؤقت للتطبيق، لن يتم حذف سجلات المحادثة والأدوار',
    cleaning: 'جاري المسح',
    cleaningComplete: 'اكتمل المسح',
  },
  profile: {
    title: 'تعديل الملف الشخصي',
    yourAvatar: 'صورتك الرمزية',
    whatCallMe: 'ماذا تريد أن يناديك الذكاء الاصطناعي',
    yourName: 'اسمك',
    yourAge: 'عمرك',
    race: 'العرق',
    pleaseSelect: 'الرجاء الاختيار',
    yourWeight: 'وزنك',
    yourHeight: 'طولك',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    neutral: 'محايد',
    hobby: 'الهواية',
    pleaseEnter: 'الرجاء الإدخال...',
    favoriteFood: 'الطعام المفضل',
    yourCharacter: 'شخصيتك',
    fantasyAboutOtherHalf: 'خيالك عن شريك حياتك',
    uploading: 'جاري الرفع...',
    enterName: 'الرجاء إدخال اسمك',
  },
  report: {
    title: 'إبلاغ',
    chooseReact: 'اختر ما تريد الإبلاغ عنه...',
    other: 'آخر',
    placeholder: 'اكتب ما تريد قوله...',
    submit: 'إرسال',
    pleaseEnterContent: 'الرجاء إدخال المحتوى',
  },
  edit: {
    placeholder: 'عدّل رسالتك...',
    cancel: 'إلغاء',
    save: 'حفظ',
    saving: 'جاري الحفظ...',
  },
  firstConfirmName: {
    canYouTellMeName: 'هل يمكنك إخباري باسمك؟ بهذه الطريقة يمكنني مناداتك بشكل أفضل!',
    yourName: 'اسمك',
    confirm: 'تأكيد',
  },
  toast: {
    translating: 'جاري الترجمة...',
    translate: 'ترجمة',
    translationFailed: 'فشلت الترجمة',
    translationUnlocked: 'تم فتح الترجمة',
    translationLocked: 'تم قفل الترجمة',
    download: 'تحميل',
    setAsBackdrop: 'تعيين كخلفية',
    goChat: 'اذهب للمحادثة',
  },
  videoPreview: {
    failedToLoad: 'فشل تحميل الفيديو',
  },
  imagePreview: {
    imageLoadFailed: 'فشل تحميل الصورة',
    preview: 'معاينة الصورة',
    afterSendIntimacy: 'بعد إرسال رسالة إلى الشخصية، تحصل على الحميمية. عندما تصل الحميمية إلى مبلغ محدد، يمكن فتح الصورة الحالية',
  },
  fqa: {
    title: 'الأسئلة الشائعة',
    description: 'هذه قائمة محدثة باستمرار من الأسئلة المتعلقة بمنتجنا. إذا كانت لديك أسئلة غير مدرجة، يرجى الذهاب إلى Discord الخاصة بنا والسؤال.',
    howAlWork: {
      title: 'كيف تعمل صديقة الذكاء الاصطناعي؟',
      content: 'في RoleplayGF، كل شيء يدور حول بناء علاقات واقعية ممتعة. نستخدم تقنية الذكاء الاصطناعي المتقدمة لتمكينك من إنشاء صديقة الذكاء الاصطناعي المثالية according to your preferences—whether that\'s a sweet and innocent petite princess or an older and more dominant woman.',
    },
    howInteract: {
      title: 'كيف تتفاعل مع صديقات الذكاء الاصطناعي؟',
      content: 'من خلال نظامنا الذكي والتعلم الآلي المتطور، يمكنك التفاعل、建立亲密关系 مع صديقة الذكاء الاصطناعي الخاصة بك. يمكنك توقع أن تستمع إليك، وتستجيب بسرعة لرسائلك، وحتى تتبع طلبات الصور like the good girl she is. كل لحظة يمكن أن تكون تجربة حقيقية وواقعية، وستكون دائمًا من يتحكم (ما لم تخبرها بخلاف ذلك).',
    },
    privacy: {
      title: 'ماذا عن خصوصيتك مع أصدقاء الذكاء الاصطناعي؟',
      content: 'اطمئن إلى أن secrets are in good hands عند استخدامك لمحادثة الذكاء الاصطناعي NSFW الخاصة بنا. خصوصيتك هي أولويتنا القصوى here at RoleplayGF، ولدينا تخزين بيانات آمن حديث، مما يضمن أن كل صورة سيلفي مغرية ورسائل flirtatious وbis whispers are kept private between you and your passionate partner. نحتفل أيضًا بتفضيلاتك دون حكم، ونمنحك الحرية في احتضان رغباتك بشكل خاص.',
    },
    customizeBehavior: {
      title: 'هل يمكنك تخصيص سلوك صديقة الذكاء الاصطناعي الخاصة بك؟',
      content: 'Only you know what you really want, which is why you can customize your entire digital girlfriend experience—from her curves and contours all the way to her personality traits and adorable little quirks. Want a naughty chat with a feisty partner? Looking to have a slow and sensual relationship with a nice, sweet girlfriend? Our realistic NSFW AI generator and NSFW AI chatbot capabilities can satisfy your heart\'s deepest desires.',
    },
  },
  store: {
    noNetwork: 'لا يوجد شبكة',
    one: 'واحد',
    noConsumptionRecords: 'لا توجد سجلات استهلاك بعد',
    transactionHistoryAppear: 'سيظهر سجل معاملاتك هنا',
    tab: 'المتجر',
    record: 'السجل',
    retry: 'إعادة المحاولة',
    rechargeFailTip: '*إذا فشلت عملية الشحن، يرجى الاتصال بنا >',
    rechargeFailTipStatic: 'إذا فشلت عملية الشحن، يرجى',
    contactUsLink: 'الاتصال بنا',
    popular: 'شائع',
    oneTimeOnly: 'مرة واحدة فقط',
    loading: 'جاري التحميل...',
    noMoreRecords: 'لا مزيد من السجلات',
    gift: 'هدية',
    retentionMessage: 'شريكك يحتاج لرفقتك، هل أنت متأكد أنك تريد التخلي؟',
  },
  mine: {
    bindEmail: 'ربط البريد الإلكتروني',
    copyFailed: 'فشل النسخ',
    backpackTitle: 'حقيبتي',
    task: 'مهمة',
  },
  messagePage: {
    noNetwork: 'لا يوجد شبكة',
  },
  search: {
    recommend: 'موصى به',
    noNetwork: 'لا يوجد شبكة',
  },
  chatSettings: {
    myGems: 'جواهري',
    title: 'إعدادات المحادثة',
    chatModel: 'نموذج المحادثة',
    chatStyle: 'أسلوب المحادثة',
    chatPerspective: 'منظور المحادثة',
    goOnButton: 'زر المتابعة',
    chatBackground: 'خلفية المحادثة',
    awayMessages: 'رسائل الغياب',
    disableAwayMessages: 'تعطيل رسائل الغياب',
    disableAwayMessagesConfirm: 'لن تتمكن من مراسلتك أثناء غيابك. هل أنت متأكد أنك تريد تعطيل رسائل الغياب؟',
    videoFailedToLoad: 'فشل تحميل الفيديو',
  },
  history: {
    deleteHistory: 'حذف السجل',
    deleteCharacterHistory: 'هل أنت متأكد أنك تريد حذف سجل هذه الشخصية؟',
  },
  tab: {
    maxSelection: 'يمكن اختيار',
    tags: 'وسوم كحد أقصى',
  },
  noNewMessage: 'لا توجد رسالة جديدة',

  // إعادة تحميل الرسالة
  reloadMessage: {
    title: 'اختر تفضيلك',
    before: 'قبل',
    new: 'جديد',
    loading: 'جار التحميل...',
    noNewMessage: 'لا توجد رسالة جديدة',
    tryAgain: 'حاول مرة أخرى',
    confirm: 'تأكيد',
  },

  account: {
    copiedToClipboard: 'تم النسخ إلى الحافظة',
    copyFailed: 'فشل النسخ',
    aboutAccount: 'حول الحساب',
    id: 'المعرف',
    email: 'البريد الإلكتروني',
    copied: 'تم النسخ إلى الحافظة',
  },
  rate: {
    title: 'قيمنا',
  },
  awayMessages: {
    disableAwayMessages: 'تعطيل رسائل الغياب',
    disableConfirm: '{appName} لن تتمكن من مراسلتك أثناء غيابك. هل أنت متأكد أنك تريد تعطيل رسائل الغياب؟',
  },
  login: {
    title: 'ربط البريد الإلكتروني',
    subtitle: 'يرجى ربط بريدك الإلكتروني لضمان أمان بيانات حسابك.',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    signIn: 'تسجيل الدخول',
    signUp: 'التسجيل',
    signInWithGoogle: 'تسجيل الدخول بجوجل',
    signInWithEmail: 'تسجيل الدخول بالبريد',
    signInWithPhone: 'تسجيل الدخول بالهاتف',
    signInWithApple: 'تسجيل الدخول بأبل',
    dontHaveAccount: 'ليس لديك حساب بعد؟',
    register: 'تسجيل',
    bySigningUp: 'بالتسجيل، أنت توافق على',
    userAgreement: 'اتفاقية المستخدم و',
    privacyPolicy: 'سياسة الخصوصية.',
    guestMode: 'وضع الضيف',
    registerTitle: 'يبدأ التسجيل',
    registerSubtitle: 'يرجى ربط بريدك الإلكتروني لضمان أمان بيانات حسابك.',
    alreadyHaveAccount: 'لديك حساب بالفعل؟',
    pleaseInputPasswordAndEmail: 'يرجى إدخال كلمة المرور والبريد الإلكتروني',
    pleaseInputCorrectEmail: 'يرجى إدخال بريد إلكتروني صحيح',
    pleaseInputCorrectPassword: 'يجب أن تكون كلمة المرور بين 6-30 حرفًا',
    male: 'ذكر',
    female: 'أنثى',
    neutral: 'محايد',
    loggingIn: 'جاري الدخول...',
    loading: 'جاري التحميل...',
    releaseToRefresh: 'أفلت للتحديث',
    loginFailed: 'فشل تسجيل الدخول',
    loginSuccess: 'تم التسجيل بنجاح',
    registerFailed: 'فشل التسجيل',
    registerSuccess: 'نجاح التسجيل',
    confirm: 'تأكيد',
  },
  loadingMore: 'جاري تحميل المزيد من الرسائل...',
  noMoreMessages: 'لا مزيد من الرسائل',

  // VIP page
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: 'استعادة المشتريات',
  },

  // Common dialogs
  dialog: {
    ok: 'موافق',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    close: 'إغلاق',
    retry: 'إعادة المحاولة',
    processing: 'جاري المعالجة...',
    contactUs: 'اتصل بنا',
    loginError: 'خطأ في تسجيل الدخول',
    loginErrorMessage: 'يرجى الخروج من البرنامج وإعادة تشغيل التطبيق أو الاتصال بنا',
    insufficientEnergy: 'طاقة غير كافية!',
    insufficientEnergyDesc: 'كل رسالة تكلف 1 طاقة. تستعيد 1 طاقة كل ساعة.',
    consumesGems: 'تستهلك {gems} جواهر',
    insufficientPhysicalStrengthTitle: 'قوة فيزيائية غير كافية',
    needStrengthToContinue: 'تحتاج إلى {strength} من القوة لمواصلة هذه المحادثة',
    getStrength: 'احصل على طاقة',
    getGems: 'احصل على الجواهر',
  },

  // AppNewUser
  appNewUser: {
    title: 'حصري للمستخدمين الجدد',
    ok: 'موافق',
  },

  // Rating popup
  rating: {
    title: 'قيمنا',
    description1: 'هل تحب تطبيقنا؟',
    description2: 'يرجى تقييمانا بـ 5 نجوم.',
    rateButton: 'قيمنا الآن',
  },

  // Version update
  versionUpdate: {
    title: 'تحديث الإصدار',
    updateContent: 'محتوى التحديث',
    updateNow: 'تحديث الآن',
    updating: 'جاري التحديث...',
    clientOptimization: 'تحسين تجربة العميل',
    bugFix: 'إصلاح المشاكل المعروفة',
  },

  // Store

  // Message detail page
  messageDetail: {
    free: 'مجاني',
    perMessage: '/رسالة',
    increaseFavorability: 'أرسل رسائل لزيادة القرب',
    album: 'الألبوم',
    intro: 'مقدمة',
    noIntro: 'لا توجد مقدمة بعد. الدردشة واكتشف بنفسك.',
    tags: 'العلامات',
    backToChat: 'العودة للدردشة',
    levelFormat: 'المستوى {level}',
    messageCount: '{count} رسالة',
    chatMateTyping: 'شريك الدردشة الخاص بك يكتب الآن...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: 'يمكنك عرض أفكار الشخصية الداخلية عند الرد على الرسائل، لكن سرعة الرد قد تكون أبطأ.',
  },

  // Chat select menu
  chatSelect: {
    copy: 'نسخ',
    report: 'إبلاغ',
    create: 'إنشاء',
    video: 'فيديو',
    translate: 'ترجمة',
    delete: 'حذف',
  },

  // Recommended purchases
  recommended: {
    gift: 'هدية',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: 'وضع التفكير غير متاح لهذا النموذج حتى الآن، لكننا نعمل على ذلك...',
  },

  // First charge popup
  firstCharge: {
    title: 'أول عملية شحن',
    get: 'احصل',
    limitedOffer: 'عرض محدود الوقت',
    priceFormat: '${price} احصل',
    congratulations: 'تهانينا! أنت الآن عضو VIP رسمي~!',
    missOfferTitle: 'هل أنت متأكد أنك تريد تفويت هذا العرض؟',
    maybeLater: 'ربما لاحقاً',
    getNow: 'احصل الآن',
    benefit1: 'احصل على 130 جوهرة مجانية',
    benefit2: 'فتح جميع الشخصيات',
    benefit3: 'ذاكرة 12x',
    benefit4: 'تسجيل دخول أسبوعي غير محدود',
    benefit5: 'تجربة بدون إعلانات',
    buyNow: 'اشترِ الآن',
  },

  // Check-in center
  checkIn: {
    freeGems: 'جواهر مجانية',
    sevenDayCheckIn: 'تسجيل دخول 7 أيام',
    memberExclusive: 'تسجيل دخول حصري للأعضاء:',
    signInTip: 'سجل دخول يومياً لتجميع مكافآت لا نهائية',
    getVip: 'احصل على VIP',
    plusExtra: 'Plus+{count}',
    getGemsCount: 'احصل على {count} جواهر',
    extraDaily: '{count} جواهر يومية إضافية',
    ultra: 'Ultra',
    signedInTip: 'لقد سجل دخولك اليوم. عد غداً لمزيد من المكافآت!',
    tasks: 'المهام',
    go: 'انتقل',
    received: 'تم الاستلام',
    receive: 'استلم',
    day: 'اليوم {num}',
  },

  // Account page
  loginPage: {
    confirm: 'تأكيد',
  },

  // Copyright
  copyright: {
    title: 'شروط الاستخدام',
  },

  // Copy
  copy: {
    copiedToClipboard: 'تم النسخ إلى الحافظة',
    copyFailed: 'فشل النسخ',
  },

  // Errors
  errors: {
    networkError: 'خطأ في الشبكة',
    pleaseSelectFilter: 'يرجى تحديد شروط التصفية',
    retry: 'إعادة المحاولة',
  },

  // Terms of Service
  terms: {
    intro: 'بزيارة موقع {appName} واستخدامه، فإنك توافق على الالتزام بشروط الاستخدام هذه.',
    section1Title: '1. استخدام الموقع',
    section1_1: 'يجب أن تكون عمره 13 عامًا على الأقل لاستخدام هذا الموقع.',
    section1_2: 'أنت مسؤول عن الحفاظ على سرية حسابك وكل النشاط الذي يحدث تحت حسابك.',
    section1_3: 'يحظر استخدام الموقع لأي غرض غير قانوني أو بموجب هذه الشروط.',
    section2Title: '2. الملكية الفكرية',
    section2_1: 'جميع المحتويات والميزات والوظائف على {appName}، بما في ذلك النصوص والرسومات والشعارات والصور والبرمجيات، هي ملك لـ {appName} أو مرخصة له وهي محمية بموجب قوانين الملكية الفكرية.',
    section2_2: 'لا يجوز نسخ أو إعادة توزيع أو إنشاء أعمال مشتقة من أي محتوى على الموقع دون إذن كتابي مسبق.',
    section3Title: '3. الخصوصية',
    section3_1: 'سياسة الخصوصية الخاصة بنا، المتاحة على الموقع، توضح كيفية جمع واستخدام والكشف عن معلوماتك الشخصية.',
    section4Title: '4. إخلاء المسؤولية من الضمانات',
    section4_1: 'الموقع والخدمات المقدمة "كما هي" و"كما هي متاحة" دون أي إقرارات أو ضمانات من أي نوع، صريحة أو ضمنية.',
    section5Title: '5. تحديد المسؤولية',
    section5_1: 'بأقصى حد يسمح به القانون، لن تكون {appName} مسؤولة عن أي أضرار مباشرة أو غير مباشرة أو عرضية أو خاصة أو تبعية.',
    section6Title: '6. التعويض',
    section6_1: 'أنت توافق على تعويض والدفاع عن {appName} وواضعيها ومديرينا وموظفينا من وضد أي مطالبات أو أضرار أو التزامات وخسائر وتكاليف ونفقات، بما في ذلك أتعاب المحاماة، الناشئة عن أو المتعلقة باستخدامك للموقع.',
    section7Title: '7. القانون الحاكم',
    section7_1: 'تخضع شروط الاستخدام هذه وتفسر وفقًا لقوانين الدولة، بغض النظر عن تعارضها مع أحكام القانون.',
    section8Title: '8. التغييرات على الشروط',
    section8_1: 'نحتفظ بالحق في تعديل أو استبدال هذه الشروط في أي وقت حسب تقديرنا.',
    section9Title: '9. اتصل بنا',
    section9_1: 'إذا كانت لديك أي أسئلة حول هذه الشروط، يرجى الاتصال بنا.',
  },
}
